import { defineEvent } from '../types/event';
export var ZOOM_LAUNCH = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Launched_Zoom'
        }
    ]
});
